module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-zh-TW.2a26f4c0.jpg";